import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Component, Input, OnInit, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../_shared/services';
import { formatDropdownValue, getEnumFromString } from '../../../../../_shared/helpers/kpiWidget/kpi-formatters.helper';
import { MeasurementTypes } from '../../../../../_shared/enums/kpiStats/measurement-types.enum';
import { AccountFilterData, DateIntervalFilterData } from '../../../../../_shared/models';
import { FuelKpiRequest } from '../../../../_shared/models';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FuelConsumptionService } from '../../../services/fuel-consumption.service';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { isUptrendPositive } from '../../../../../_shared/helpers/kpiWidget/dropdown-measurement.helper';
import { KpiWidgetComponent, DropdownOption } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';

@Component({
  selector: 'app-fuel-efficiency-widget',
  standalone: true,
  imports: [TranslocoPipe, KpiWidgetComponent],
  templateUrl: './fuel-efficiency-widget.component.html',
  styleUrl: './fuel-efficiency-widget.component.scss'
})
export class FuelEfficiencyWidgetComponent extends BaseWidgetComponent implements OnInit {
  private readonly transloco = inject(TranslocoService);
  @Input() dateFilter: DateIntervalFilterData;
  @Input() accountFilter: AccountFilterData;
  @Input() modalFilterHeaders: { previous: string; current: string };

  icon: string = "assets/images-fuel/fulePampIcon.svg"
  fuelEfficiencyPercentageChange: any;
  hasError: boolean = false;
  errorMessage: string = '';
  request: FuelKpiRequest;
  selectedUnit: string = MeasurementTypes.FuelEconomy.toString();
  dropdownEnabled: boolean = true;
  dropdownOptions: DropdownOption[] = [
    { label: this.transloco.translate('fuelDashboard.units.kmPerLitres'), value: MeasurementTypes.FuelEconomy.toString(), unit: 'km/ℓ' },
    { label: this.transloco.translate('fuelDashboard.units.litresPer100Km'), value: MeasurementTypes.FuelConsumption.toString(), unit: 'ℓ/100km' }
  ];

  constructor(
    private fuelConsumptionService: FuelConsumptionService,
    protected override filterService: FilterService,
    private modalService: NgbModal,
    private errorHandlerService: ErrorHandlerService
  ) {
    super(filterService);
    this.title = 'Fuel Efficiency';
    this.isLoading = true;
    this.value = 0;
    this.difference = 0;
    this.widgetDisabled = true;
  }

  ngOnInit(): void {
    this.selectedUnit = this.dropdownOptions[0].value;
  }

  async onFilterChangeAsync(): Promise<void> {
    await this.getFuelEfficiencyKpiStats();
  }

  async onDropdownChanged(selectedOption: DropdownOption): Promise<void> {
    this.selectedUnit = selectedOption.value;
    this.request.fuelMeasurementType = getEnumFromString(selectedOption.value);
    await this.getFuelEfficiencyKpiStats();
  }

  formatValue(value: number): string {
    return formatDropdownValue(value, this.selectedUnit, this.dropdownOptions, getEnumFromString);
  }

  get isUptrendPositive(): boolean {
    return isUptrendPositive(getEnumFromString(this.selectedUnit));
  }

  async getFuelEfficiencyKpiStats() {
    this.isLoading = true;
    this.hasError = false;

    try {
      this.request = {
        accountIds: this.widgetFilter.accountIds,
        timeFrom: this.widgetFilter.startDate!,
        timeTo: this.widgetFilter.endDate!,
        previousTimeFrom: this.widgetFilter.previousCycleStartDate!,
        previousTimeTo: this.widgetFilter.previousCycleEndDate!,
        fuelMeasurementType: getEnumFromString(this.selectedUnit)
      }

      this.cancelSubject.next();
      const response = await this.fuelConsumptionService.getFuelEfficiencyKpiStats(this.request, this.cancelSubject);
      this.value = response.data?.totalValue ?? 0;
      this.fuelEfficiencyPercentageChange = response.data?.percentageChange;
      this.isLoading = false;
    } catch (error: any) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }

  // openFuelEfficiencyModal(): void {
  //   const modalOptions: NgbModalOptions = {
  //     centered: true,
  //     backdrop: 'static',
  //     size: 'xl',
  //     windowClass: 'custom-modal-class',
  //   };
  //   const modalRef = this.modalService.open(FuelEfficiencyModal, modalOptions);
  //   modalRef.componentInstance.request = this.request;
  //   modalRef.componentInstance.modalFilterHeaders = this.modalFilterHeaders;
  // }
}